import React from 'react';
import CurrencyFormat from 'react-currency-format';
import styled from 'styled-components';

import { colors } from '../../../core';
import Label from '../Label';

export interface CurencyInputProps {
  id?: string;
  width?: string;
  label?: string;
  onChange: (values: string) => void;
  thousandSeparator?: boolean;
  prefix?: string;
}

const Container = styled.div<{ width: string }>`
  width: ${({ width }) => width};
`;

const StyledCurrencyFormat = styled(CurrencyFormat)`
  -webkit-appearance: none;
  border: 1px solid ${colors.smoke};
  border-radius: 3px;
  color: ${colors.ash};
  display: block;
  font-family: ${({ theme }) => theme.fontFamily || `Quicksand, san-serif`};
  font-size: ${({ theme }) => theme.fontSize || '14px'};
  font-weight: ${({ theme }) => theme.fontWeight || 600};
  padding: 8px 10px;
  width: 100%;

  ::placeholder {
    color: ${colors.smoke};
  }

  &:hover {
    box-shadow: 0 2px 4px 0 rgba(217, 217, 217, 0.5);
  }

  &:active,
  &:focus {
    color: ${colors.charcoal};
    border-color: ${colors.primary};
    outline: 0;
  }

  &:disabled {
    background-color: ${colors.pearl};
    border-color: ${colors.cloud};
    box-shadow: none;
    color: ${colors.smoke};
    cursor: default;
  }
`;

const CurrencyInput = ({ width = '100%', label, onChange, ...inputProps }: CurencyInputProps) => (
  <Container width={width}>
    {label && <Label htmlFor={inputProps.id}>{label}</Label>}
    <StyledCurrencyFormat onValueChange={(values: string) => onChange(values)} {...inputProps} />
  </Container>
);

export default CurrencyInput;
